export const COUNTRY_LOCAL = 'GT'
export const LOCALE_CURRENCY = 'es-GT'
